import { render, staticRenderFns } from "./ReunionComponent.vue?vue&type=template&id=27098136&"
import script from "./ReunionComponent.vue?vue&type=script&lang=js&"
export * from "./ReunionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports